import { Component, EventEmitter, Input, Output, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase, LocationInfo, OrderCustomerModel } from 't4core';
import { OrderCustomerInfo } from '../../../../projects/t4core/src/lib/models/contracts/Turbo.Data.Contracts';


@Component({
  selector: 't4-order-customer-link',
  templateUrl: './orderCustomerLink.html',
})
export class T4OrderCustomerLink extends ComponentBase {
  private _customerId: number;
  public get locationId(): number { return this._customerId; }
  @Input() public set locationId(value: number | null) {
    if (!value) return;

    var val = parseInt(value.toString());
    if (this._customerId != val) {
      this._customerId = val;
      if (this.content.nativeElement.childNodes.length == 0) this.loadCustomer();
      this.customer = undefined;
    }
  };

    @Output() public mouseOver = new EventEmitter<OrderCustomerModel>();
    @Output() public mouseOut = new EventEmitter<OrderCustomerModel>();
    @Output() public clicked = new EventEmitter<OrderCustomerModel>();


  @ViewChild("ref", { static: true }) public content: ElementRef;

    public customer: OrderCustomerModel;
  public isLoading: boolean = false;
  public displayTooltip: boolean = false;
  public hidingTooltip: boolean = false;

  constructor(private route: Router, private activeRoute: ActivatedRoute) {
    super();
  }

    private loadCustomer() {
    this.isLoading = true;

        this.Api.get<OrderCustomerModel>("TurboOrder/GetCustomer", { id: this._customerId }).then(x => {
      this.customer = x;
      this.mouseOver.emit(this.customer);
    });
  }

  public show() {
    this.hidingTooltip = false;
    this.displayTooltip = true;
    if (!this.customer) {
        this.loadCustomer();
    } else {
      this.mouseOver.emit(this.customer);
    }
  }

  public hide() {
    this.hidingTooltip = true;
    setTimeout(() => {
      if (this.hidingTooltip) {
        this.displayTooltip = false;
        this.mouseOut.emit(this.customer);
      }
    }, 100);
  }

    public async open() {
        if (this.customer.AxCustomerNo) {
            this.mouseOut.emit(this.customer);
            this.route.navigateByUrl("/TurboOrder/Customer/" + this.customer.XalAccountNo);
        }
  }
}
